import { filtersFormController } from 'magner';
import { baseT } from 'configs/translation/base';
import { t } from 'features/users/clients/ru';
import { bannersT } from './index';
import { searchCities } from '~/utils/searchInit';
import { linksList } from './requests';

const bannersFilters = filtersFormController<any>({
  saveToLocalStorage: true,
  actions: [
    {
      type: 'link',
      to: { name: 'banners-edit', params: { id: 'new' } },
      props: {
        type: 'primary',
        class: 'blue-btn',
        text: baseT('form.create_new_button'),
      },
    },
  ],
  submitEvent: 'input',
  sort: {},
  pagination: {
    items: 25,
    page: 1,
  },
  filtersData: {
    title: '',
    cities: '',
    transition: '',
    date: '',
    links: '',
  },
  layout: [
    {
      type: 'input',
      name: 'title',
      props: {
        placeholder: bannersT('filters.title'),
        inputDelay: 250,
      },
    },
    {
      type: 'select',
      name: 'cities' as 'city',
      options: [],
      props: {
        placeholder: t('filters.city'),
        multiple: true,
        collapseTags: true,
        clearable: true,
        remote: true,
        valueKey: 'id',
        labelKey: 'name',
        remoteMethod: searchCities,
      },
    },
    {
      type: 'datetime',
      name: 'date',
      dataType: 'date',
      props: {
        type: 'datetimerange',
        startPlaceholder: 'От',
        endPlaceholder: 'До',
        format: 'YYYY-MM-DD HH:mm',
        rangeSeparator: '–',
      },
    },
    {
      type: 'select',
      name: 'links',
      options: [],
      props: {
        placeholder: 'Переход',
        multiple: true,
        collapseTags: true,
        clearable: true,
        remote: true,
        valueKey: 'value',
        labelKey: 'label',
        remoteMethod: linksList,
      },
    },
  ],
});

export default bannersFilters;
